import { render, staticRenderFns } from "./ProfileCardCalc.vue?vue&type=template&id=b860b532&scoped=true"
import script from "./ProfileCardCalc.vue?vue&type=script&lang=js"
export * from "./ProfileCardCalc.vue?vue&type=script&lang=js"
import style0 from "./ProfileCardCalc.vue?vue&type=style&index=0&id=b860b532&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b860b532",
  null
  
)

export default component.exports